import request from "@/utils/request";
const BASE_URL = "/EquipmentScreen";

export default {
  // 设备概况-设备
  devInfo() {
    return request({
      url: BASE_URL + '/DevInfo',
      method: 'get',
    })
  },
  // 设备概况-设备（按用户的设备权限过滤）
  devInfoByUser(userId) {
    return request({
      url: BASE_URL + '/DevInfoByUser',
      method: 'get',
      params: { userId }
    })
  },
  // 设备概况-生产时长排行Top5
  thisDayWorkHours() {
    return request({
      url: BASE_URL + '/ThisDayWorkHours',
      method: 'get',
    })
  },
  // 设备概况-近七天时长
  thisWeekWorkHours() {
    return request({
      url: BASE_URL + '/ThisWeekWorkHours',
      method: 'get',
    })
  },
  // 设备概况-设备轮播
  getEquipmentList(data) {
    return request({
      url: BASE_URL + '/GetEquipmentList',
      method: 'post',
      data,
    })
  },
  // 实时数据
  eqRealtimeMould(data) {
    return request({
      url: BASE_URL + '/EqRealtimeMould',
      method: 'post',
      data,
    })
  },
  // (故障)分析-设备状态
  analysisDevFailure() {
    return request({
      url: BASE_URL + '/AnalysisDevFailure',
      method: 'get',
    })
  },
  // (故障)分析-实时设备告警
  analysisRealtimeDevWarn(data) {
    return request({
      url: BASE_URL + '/AnalysisRealtimeDevWarn',
      method: 'post',
      data,
    })
  },
  // (故障)分析-周告警趋势
  analysisWarnWeek() {
    return request({
      url: BASE_URL + '/AnalysisWarnWeek',
      method: 'post',
    })
  },
  // (故障)分析-当天告警设备Top5
  analysisWarnDev() {
    return request({
      url: BASE_URL + '/AnalysisWarnDev',
      method: 'post',
    })
  },
  // (故障)分析-当天告警类型Top5
  analysisWarnType() {
    return request({
      url: BASE_URL + '/AnalysisWarnType',
      method: 'post',
    })
  },
  // (故障)分析-周故障工时趋势
  analysisFailureWeek() {
    return request({
      url: BASE_URL + '/AnalysisFailureWeek',
      method: 'post',
    })
  },
  // (故障)分析-月故障机台top5
  analysisFailureTop() {
    return request({
      url: BASE_URL + '/AnalysisFailureTop',
      method: 'post',
    })
  },
  // (故障)分析-月故障类型top5
  analysisFailureType() {
    return request({
      url: BASE_URL + '/AnalysisFailureType',
      method: 'post',
    })
  },
  // (故障)分析-实时故障告警 (EquipmentNo=机器编号;FailureTime=报障时间;FailureRemark=报障内容)
  analysisFailureRealTime(data) {
    return request({
      url: BASE_URL + '/AnalysisFailureRealTime',
      method: 'post',
      data
    })
  },
}